import createVueApp from '@phoenix/createVueApp';
import StrapFinderSearch from '@maison/components/strapFinder/StrapFinderSearch.vue';

document.querySelectorAll('.phoenix-strap-finder-search').forEach((el) => {
  const app = createVueApp();
  app.component('StrapFinderSearch', StrapFinderSearch);
  app.mount(el);
});
